/*import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc';

import {authConfig} from "./login/auth.config";*/
import {Component} from '@angular/core';
import {ShowHideConLog} from '../../src/app/shared/my-constants';

// declare const speechInput: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: []
})
export class AppComponent {
    title = 'app';

    constructor() {
        // speechInput.onLoad("andrew@kairo.com");
        if(ShowHideConLog){
            console.log = function() {}
            console.error = function() {}
            console.warn = function() {}
            console.info = function() {}
            console.debug = function() {}
        }
    }

    /* constructor(private oauthService: OAuthService) {
       this.configureWithNewConfigApi();
     }*/
    /*  private configureWithNewConfigApi() {
        this.oauthService.configure(authConfig);
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        this.oauthService.loadDiscoveryDocumentAndTryLogin();
      }*/
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/app.component.ts